"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnumValue = exports.enumValue = exports.isEnumKey = exports.enumKey = void 0;
function enumKey(arg, val) {
    if (isEnumKey(arg, val)) {
        return val;
    }
    else if (isEnumValue(arg, val)) {
        return arg[val];
    }
    return undefined;
    // if (typeof val === "string") {
    //   return val as keyof TEnum
    // }
    // return arg[val as keyof TEnum] as unknown as keyof TEnum
}
exports.enumKey = enumKey;
function isEnumKey(arg, val) {
    return typeof val === "string" && arg[arg[val]] === val;
}
exports.isEnumKey = isEnumKey;
function enumValue(arg, val) {
    if (isEnumValue(arg, val)) {
        return val;
    }
    else if (isEnumKey(arg, val)) {
        return arg[val];
    }
    return undefined;
    // if (typeof val === "number") {
    //   return val as TEnum[keyof TEnum]
    // }
    // return arg[val as keyof TEnum] as unknown as TEnum[keyof TEnum]
}
exports.enumValue = enumValue;
function isEnumValue(arg, val) {
    return typeof val === "number" && arg[arg[val]] === val;
}
exports.isEnumValue = isEnumValue;
